import type { PhotoEffectId } from '@/lib/photo-effects/types/photo-effect-id'

export function photoEffectRowLabelId(id: PhotoEffectId): string {
  return `photo-effect-${id}-label`
}

export function photoEffectRowRangeHintId(id: PhotoEffectId): string {
  return `photo-effect-${id}-range-hint`
}

export function photoEffectRowLiveValueId(id: PhotoEffectId): string {
  return `photo-effect-${id}-live-value`
}

/** WMPCM-9494 — symmetric midpoint reads as neutral for screen readers. */
export function formatPhotoEffectSliderAriaValueText(
  mode: 'symmetric' | 'percent',
  value: number
): string {
  if (mode === 'symmetric' && value === 0) {
    return '0, neutral'
  }

  return String(value)
}

export function formatPhotoEffectRangeHint(min: number, max: number): string {
  return `${min} to ${max}`
}
